export default __webpack_public_path__ + "static/media/createActionH4@3x.7d68f372.png";